// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c901b7f0","488":"ff059cc1","732":"1b08054c","977":"feb75160"}[chunkId] + ".chunk.js";
};